<template>
  <ArtLibraryDialog
    v-if="artDialogShow"
    ref="artLibraryDialogRef"
    :dialogType="artDialogType"
    :parmas="currentArtInfo"
    @onClose="onCloseDialog"
    @onConfirm="onConfirmDialog"
  />
  <ArtImportDialog
    v-if="artImportDialogShow"
    :dialogType="0"
    :file="currentFile"
    :parmas="excelJson"
    @onClose="onCloseDialog"
    @onConfirm="onImportConfirmDialog"
  />
  <ArtBatchDialog
    v-if="batchDialogShow"
    :mode="batchMode"
    :file="batchFile"
    :selected="batchSelected"
    @onClose="onCloseBatchDialog"
    @onConfirm="onBatchConfirm"
  />
  <ArtPresetDialog
    v-if="presetDialogShow"
    mode="business"
    :can-import="editPermission"
    @onClose="onClosePresetDialog"
  />
  <CreateDialog ref="createDialogRef" />

  <div class="AccountArtLibraryList glossary-library">
    <input
      ref="batchFileInputRef"
      type="file"
      accept=".xls,.xlsx"
      hidden
      @change="onBatchFileChange"
    />
    <el-upload
      id="art-upload"
      ref="uploadRef"
      class="glossary-upload"
      action=""
      :key="uploadKey"
      :before-upload="handleBeforeUpload"
      :on-change="handleUploadFile"
      :webkitdirectory="false"
      :mozdirectory="false"
      :auto-upload="false"
      :show-file-list="false"
      accept=".xls, .xlsx"
      :multiple="false"
    />

    <AccountArtEditList
      v-if="isEdit"
      :termInfo="currentArtInfo"
      @onUpPro="onUpPro"
      @updataList="requestFileList(false, true)"
    />

    <div v-else class="glossary-library__body">
      <div v-if="selectedCount > 0" class="glossary-selection-bar">
        <strong>{{ $t('art_selected_count').replace('*', String(selectedCount)) }}</strong>
        <button type="button" @click="onBatchExport">{{ $t('art_selected_export') }}</button>
        <button class="is-danger" type="button" :disabled="!canDeleteSelected" @click="onDeleteArt">
          {{ $t('art_selected_delete') }}
        </button>
        <button class="is-cancel" type="button" @click="resetParams">{{ $t('art_selected_cancel') }}</button>
      </div>

      <div v-else class="glossary-toolbar">
        <label class="glossary-search">
          <WorkbenchIcon name="glossary-search" :size="14" />
          <input v-model="searchString" type="search" :placeholder="$t('art_search')" />
        </label>

        <div class="glossary-toolbar__group">
          <div class="glossary-menu-wrap" @click.stop>
            <button
              class="glossary-button glossary-button--secondary"
              type="button"
              :aria-expanded="openMenu === 'more'"
              @click="toggleMenu('more')"
            >
              {{ $t('art_more') }}
              <WorkbenchIcon name="glossary-chevron-down" :size="12" />
            </button>
            <div v-if="openMenu === 'more'" class="glossary-menu glossary-menu--more">
              <button type="button" @click="runMenuAction(onBatchExport)">
                <WorkbenchIcon name="glossary-download" :size="14" />
                <span><strong>{{ $t('art_batch_export') }}</strong><small>{{ $t('art_more_export_tip') }}</small></span>
              </button>
              <button type="button" @click="runMenuAction(onBatchImport)">
                <WorkbenchIcon name="glossary-upload" :size="14" />
                <span><strong>{{ $t('art_batch_import') }}</strong><small>{{ $t('art_more_import_tip') }}</small></span>
              </button>
              <span class="glossary-menu__divider" />
              <button type="button" @click="runMenuAction(onDownloadFile)">
                <WorkbenchIcon name="glossary-file-down" :size="14" />
                <span><strong>{{ $t('art_more_template_title') }}</strong><small>{{ $t('art_more_template_tip') }}</small></span>
              </button>
            </div>
          </div>

          <div class="glossary-menu-wrap" @click.stop>
            <button
              class="glossary-button glossary-button--primary"
              type="button"
              :aria-expanded="openMenu === 'new'"
              @click="toggleMenu('new')"
            >
              <WorkbenchIcon name="glossary-plus" :size="13" />
              {{ $t('art_create_title') }}
              <WorkbenchIcon name="glossary-chevron-down" :size="12" />
            </button>
            <div v-if="openMenu === 'new'" class="glossary-menu glossary-menu--new">
              <button type="button" @click="runMenuAction(onCreateArt)">
                <WorkbenchIcon name="glossary-plus" :size="14" />
                <span><strong>{{ $t('art_new_manual_title') }}</strong></span>
              </button>
              <button type="button" @click="runMenuAction(onUploadFile)">
                <WorkbenchIcon name="glossary-file-spreadsheet" :size="14" />
                <span><strong>{{ $t('art_new_excel_title') }}</strong><small>{{ $t('art_new_excel_tip') }}</small></span>
              </button>
              <button v-if="hasPreset" type="button" @click="runMenuAction(onOpenPreset)">
                <WorkbenchIcon name="glossary-library" :size="14" />
                <span><strong>{{ $t('art_new_official_title') }}</strong><small>{{ $t('art_new_official_tip_business') }}</small></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="artLibraryList" class="glossary-table-shell">
        <div class="glossary-table-header glossary-library-grid">
          <button class="glossary-check" type="button" :aria-pressed="isChooseAll" @click="onChooseAll">
            <WorkbenchIcon v-if="isChooseAll" name="glossary-check" :size="11" />
          </button>
          <span>{{ $t('art_table_title1') }}</span>
          <span>{{ $t('art_table_title2') }}</span>
          <span>{{ $t('art_table_title4') }}</span>
          <span>{{ $t('art_table_title3') }}</span>
          <span class="glossary-table-header__operation">{{ $t('art_table_title6') }}</span>
        </div>

        <div id="fileArtList" class="glossary-table-body">
          <div v-for="item in fileList" :key="item.id" class="glossary-table-row glossary-library-grid">
            <button
              class="glossary-check"
              type="button"
              :aria-pressed="Boolean(fileMap[item.id])"
              @click="onChooseItem(item)"
            >
              <WorkbenchIcon v-if="fileMap[item.id]" name="glossary-check" :size="11" />
            </button>
            <span class="glossary-name-cell">
              <button class="glossary-name" type="button" :disabled="!canModify(item)" @click="onEdit(item)">{{ item.termName }}</button>
              <span v-if="isOfficial(item)" class="glossary-official-tag">{{ $t('art_official_tag') }}</span>
              <span v-if="isOfficial(item) && item.sourceLang && item.targetLang" class="glossary-lang-pair">{{ item.sourceLang }} → {{ item.targetLang }}</span>
            </span>
            <span>{{ item.entryNum }}</span>
            <span>{{ isOfficial(item) ? $t('art_official_tag') : (item.bizTeamMemberName || '—') }}</span>
            <span>{{ formatDate(item.updateTime, '', false) }}</span>
            <span class="glossary-row-actions">
              <button type="button" :disabled="!canModify(item)" @click="onResetName(item)">{{ $t('art_file_reset_name') }}</button>
              <button type="button" :disabled="!canModify(item)" @click="onEdit(item)">{{ $t('art_edit') }}</button>
              <button class="is-danger" type="button" :disabled="!canModify(item)" @click="onDelete(item)">{{ $t('art_delete') }}</button>
            </span>
          </div>

          <div v-if="fileList.length === 0 && !initialListPending" class="glossary-empty">
            <span class="glossary-empty__icon"><WorkbenchIcon name="glossary-book-marked" :size="28" /></span>
            <strong>{{ searchString.length ? $t('art_not_search') : $t('art_blank_title') }}</strong>
            <template v-if="searchString.length === 0">
              <p>{{ $t('art_library_title_tip') }}</p>
              <button class="glossary-button glossary-button--primary" type="button" @click="onCreateArt">
                <WorkbenchIcon name="glossary-plus" :size="14" />
                {{ $t('art_create_title') }}
              </button>
              <div class="glossary-empty__links">
                <button type="button" @click="onDownloadFile">{{ $t('art_download_excel') }}</button>
                <span />
                <button type="button" @click="onUploadFile">{{ $t('art_import_excel') }}</button>
                <span />
                <button type="button" @click="onBatchImport">{{ $t('art_batch_import') }}</button>
                <template v-if="hasPreset">
                  <span />
                  <button type="button" @click="onOpenPreset">{{ $t('art_preset_entry') }}</button>
                </template>
              </div>
              <button class="glossary-empty__help" type="button" @click="onDescribe">
                {{ $t('art_blank_tip') }}
                <WorkbenchIcon name="glossary-chevron-right" :size="13" />
              </button>
            </template>
          </div>
        </div>
      </div>

      <div v-if="fileList.length > 0 || pageNum !== 1" class="glossary-pagination">
        <span>{{ $t('art_total_count').replace('*', String(totalCount)) }}</span>
        <PageNation :page="pageNum" :hasMore="hasMore" @changePage="onChangePage" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {ElLoading} from "element-plus";
// import {
//   getRequestUserTermlist,
//   getRequestCreateTerm,
//   getRequestEditTerm,
//   getRequestDeleteTerm
// } from "@/net/upload"
import AccountServer from "@/services/AccountServer"
import {getExcelJson, getArrangeCount, getRowsCount} from "~/utils/ExcelUtils"
import Toast from "~/utils/toast";
import PageNation from "@/components/PageNation/PageNation.vue"
import ArtLibraryDialog from "@/components/Translate/Art/ArtLibraryDialog.vue"
import ArtImportDialog from "@/components/Translate/Art/ArtImportDialog.vue"
import ArtBatchDialog from "@/components/Translate/Art/ArtBatchDialog.vue"
import ArtPresetDialog from "@/components/Translate/Art/ArtPresetDialog.vue"
import AccountArtEditList from "@/components/Translate/Art/AccountArtEditList.vue"
import CreateDialog from "@/components/Translate/Dialog/CreateDialog.vue"
import WorkbenchIcon from '@/components/Workbench/WorkbenchIcon.vue'

import {computed, defineEmits, defineExpose, watch ,onMounted, onUnmounted, nextTick} from "vue";
import {useRuntimeConfig} from "nuxt/app";
// import {useRouter, useRoute} from "vue-router";
import useUserStore from "@/store/modules/user";
import baseUserStore from "@/store/modules/basic";
import {storeToRefs} from "pinia";
import {useI18n} from "vue-i18n";
import eventBus from 'vue3-eventbus'
import { PermissionUtils } from "~/services/AccountServer/types";
import { EnterpriseMemberPermission } from "~/services/AccountServer/types";
import { checkPresetTermAvailable } from "~/composables/usePresetTermAvailable";
import { canModifyEnterpriseGlossary, enterpriseGlossaryContext } from "~/utils/enterpriseGlossary";

const router = useRouter()
const userStore = useUserStore();
const baseStore = baseUserStore();
const { userInfo, token, userRights, bizTeamInfo, isUserInfoReady} = storeToRefs(userStore);
const { isChina, languages} = storeToRefs(baseStore);
const appDomains = useAppDomainConfig()

const fileList = ref<{blobFileName: string, createTime: string, fileType: string, origFileName: string,
  id: number, remark: string, tmpVisitorToken: string, userId: string, visible: boolean}[]>([])
const fileMap = ref<{}>({})

const popoverRef = ref([])
const popoverRef1 = ref([])
const searchString = ref("")
const isChooseAll = ref(false)
const uploadRef = ref()
const artDialogShow = ref(false)
const artImportDialogShow = ref(false)

const artDialogType = ref(0)
const artLibraryDialogRef = ref()
const currentArtInfo = ref({})
const isEdit = ref(false)
const currentFile = ref()
const excelJson = ref()
const uploadKey = ref(0)
// 一键导出 / 一键导入
const batchDialogShow = ref(false)
const batchMode = ref<'export' | 'import'>('export')
const batchFile = ref<File | null>(null)
const batchSelected = ref<{ id: number; termName?: string }[]>([])
const batchFileInputRef = ref<HTMLInputElement | null>(null)
const presetDialogShow = ref(false)
const hasPreset = ref(false)
const openMenu = ref<'more' | 'new' | null>(null)

const route = useRoute()
const { t } = useI18n()

// 列表相关
const pageNum = ref(1)
const params = {pageSize: 12}
const hasMore = ref(true)
const totalCount = ref(0)
const createDialogRef = ref(null)
// 编辑权限
const editPermission = computed(() => PermissionUtils.hasPermission(userInfo.value?.bizMemberpermission || 0, EnterpriseMemberPermission.TERM_EDIT))
const glossaryReady = ref(false)
const initialListPending = ref(true)
const glossaryContext = computed(() => enterpriseGlossaryContext(glossaryReady.value && isUserInfoReady.value, userInfo.value))
let listRequestId = 0
const selectedCount = computed(() => Object.keys(fileMap.value).length)
const canDeleteSelected = computed(() => {
  const selected = Object.values(fileMap.value) as any[]
  return selected.length > 0 && selected.every((item) => canModify(item))
})

let call = defineEmits(["showEdit", "onUpPro"])
defineExpose({ onHideEdit })

watch(
    () => searchString.value,
    (newVal, oldVal) => {
      pageNum.value = 1
      params.prevPageId = null
      params.nextPageId = null
      requestFileList(false, true)
    },
    {
      deep: true
    }
)

// 企业归属/权限更新后重新查询，不能把首次个人模式的空结果一直留在页面。
watch(glossaryContext, (context) => {
  listRequestId++
  initialListPending.value = Boolean(context)
  fileList.value = []
  totalCount.value = 0
  pageNum.value = 1
  params.prevPageId = null
  params.nextPageId = null
  resetParams()
  if (context) requestFileList(false, true)
})

onMounted(async ()=>{
  window.addEventListener('scroll', handleScroll);
  if (route.query.recordIds) {
    let recordIds = route.query.recordIds
    params.recordIds = recordIds
  }
  document.addEventListener('click', handleClickOutside);

  checkPresetTermAvailable().then((available) => {
    hasPreset.value = available
  })
  // 进入页面时同步最新成员权限，并等待用户请求完成后再由上下文监听发起列表请求。
  try {
    await userStore.getUserInfo()
  } catch {
    // 网络失败时仅允许沿用已经由服务端确认过的身份，不使用持久化的旧企业归属。
  }
  glossaryReady.value = true
  if (!isUserInfoReady.value || !userInfo.value?.id) initialListPending.value = false
})

watch(() => route.query.preset, (value) => {
  if (!value || !import.meta.client || String(route.query.menu) !== 'glossary') return
  presetDialogShow.value = true
  const query = { ...route.query }
  delete query.preset
  router.replace({ query })
}, { immediate: true })

const drawerRef = ref<InstanceType<typeof ElDrawer> | null>(null); // 抽屉组件的引用
const handleClickOutside = (event:MouseEvent) => {
  const target = event.target as HTMLElement;
  if (!target.closest('.glossary-menu-wrap')) {
    openMenu.value = null
  }
  // 检查点击的目标是否在当前组件内
  if (!target.closest('.useFileList')&& !target.closest('.query_criteria_view')) {
      drawer.value = false; // 点击在组件外部时关闭抽屉
    }
}

function toggleMenu(menu: 'more' | 'new') {
  openMenu.value = openMenu.value === menu ? null : menu
}

function runMenuAction(action: () => void) {
  openMenu.value = null
  action()
}

function isOfficial(item: any) {
  return Number(item?.createType) === 2
}

function canModify(item: any) {
  return canModifyEnterpriseGlossary(item, userInfo.value)
}

const queryCriteriaViewRef = ref<HTMLElement | null>(null)
const fileListViewRef = ref<HTMLElement | null>(null)

// 这里相关的业务代码是兼容响应式的
const direction = ref<DrawerProps['direction']>('ttb')
const drawer = ref(false)

// 打开下啦菜单
const oponQueryCriteria = () => {
  console.log('打开弹窗')
  // drawer.value = true
  drawer.value = !drawer.value
  if(fileListViewRef.value&& queryCriteriaViewRef.value){
    const elOverlay = fileListViewRef.value.querySelector('.el-overlay')
    const rect = queryCriteriaViewRef.value.getBoundingClientRect();
    if(elOverlay){
      elOverlay.style.top = `${rect.top + rect.height}px`;
      elOverlay.style.left = `${0}px`;
    }
  }
}
// 定义滚动事件处理方法
const handleScroll = (event: Event) => {
  const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
  drawer.value = false;
  // 你可以在这里添加其他滚动事件处理逻辑
};

const isUseArt = () => {
  let currentConfig = userRights.value
  if ((!bizTeamInfo.value || !bizTeamInfo.value.id) && !userInfo.value.bizTeamId) {
    createDialogRef.value && createDialogRef.value.open(0)
    return false
  }
  console.log("isUseArt", currentConfig)
  return true
  // if (currentConfig.useTermTbFlag) {
  //   return true
  // }else {
  //   onUpPro()
  //   return false
  // }
}

const getDeleteChooses = () => {
  return Object.keys(fileMap.value).length
}

// 上传相关
function handleBeforeUpload (file) {
  // handleUploads(file,uploadIndex)
  // 返回 false 以取消自动上传
  return false;
}

async function handleUploadFile (file, files) {
  console.log("handleUploadFile", file, files)
  currentFile.value = files[0].raw
  let isError = false
  let fileJson = await getExcelJson(files[0].raw).catch((error)=>{
    isError = true
    return []
  })
  let roleConfig = userRights.value
  if (fileJson) {
    if (roleConfig.termSingleTbSize && fileJson.length > roleConfig.termSingleTbSize) {
      // 这里超出行数
      artDialogType.value = 4
      artDialogShow.value = true
    }else if (fileJson && fileJson.length > 0 && Object.keys(fileJson[0]).length <= 1) {
      // 这里列数不足两条
      artDialogType.value = 9
      artDialogShow.value = true
    }else {
      excelJson.value = {jsonList: fileJson, isError: isError}
      artImportDialogShow.value = true
    }
  }else {
    artDialogType.value = 9
    artDialogShow.value = true
  }
  setTimeout(()=>{
    uploadKey.value += 1
  },1000)
}

// 事件
function onChooseAll() {
  isChooseAll.value = !isChooseAll.value
  if (isChooseAll.value) {
    fileList.value.forEach((item)=>{
      fileMap.value[item.id] = item
    })
  }else {
    fileMap.value = {}
  }
}

function onDescribe() {
  let url = appDomains.getHelpArticleUrl('termDatabase', isChina.value)
  const link = document.createElement('a');
  link.target = '_blank'
  link.href = url;
  link.click();
}

function onUploadFile() {
  if (isUseArt()) {
    let ref = document.getElementById("art-upload").querySelector('input')
    if (ref) {
      console.log("onBtnUpload", ref)
      ref.click()
    }
  }
}

function onDownloadFile() {
  let url = `https://doclingo-pro.s3-accelerate.amazonaws.com/template/example.xlsx`
  const link = document.createElement('a');
  link.href = url;
  link.click();
}

// 一键导出：有勾选（跨页保留）只导出勾选的术语库，没有勾选则导出账号下全部
function onBatchExport() {
  if (isUseArt()) {
    batchMode.value = 'export'
    batchFile.value = null
    batchSelected.value = Object.values(fileMap.value).map((item: any) => ({ id: Number(item.id), termName: item.termName }))
    batchDialogShow.value = true
  }
}

// 一键导入：选择一键导出生成的 xlsx（或任意多 sheet 的 xlsx）
function onBatchImport() {
  if (isUseArt()) {
    batchFileInputRef.value && batchFileInputRef.value.click()
  }
}

function onBatchFileChange(event: Event) {
  const input = event.target as HTMLInputElement
  const file = input.files && input.files[0]
  // 允许重复选择同一个文件
  input.value = ''
  if (!file) return
  batchMode.value = 'import'
  batchFile.value = file
  batchDialogShow.value = true
}

// 弹窗关闭（X / 遮罩）：已有导入成功的库时同样要刷新列表
function onCloseBatchDialog(hasChange?: boolean) {
  batchDialogShow.value = false
  batchFile.value = null
  if (hasChange) {
    refreshAfterBatch()
  }
}

function onBatchConfirm(hasChange: boolean) {
  onCloseBatchDialog(hasChange)
}

function onOpenPreset() {
  presetDialogShow.value = true
}

function onClosePresetDialog(hasChange?: boolean) {
  presetDialogShow.value = false
  if (hasChange) refreshAfterBatch()
}

// 导入有成功项时回到第一页刷新
function refreshAfterBatch() {
  pageNum.value = 1
  params.prevPageId = null
  params.nextPageId = null
  resetParams()
  requestFileList(false, true)
}

// 新建术语表
function onCreateArt() {
  if (isUseArt()) {
    artDialogType.value = 0
    artDialogShow.value = true
  }
  // artImportDialogShow.value = true
}

// 删除术语表
function onDeleteArt() {
  if (canDeleteSelected.value && isUseArt()) {
    artDialogType.value = 3
    artDialogShow.value = true
  }
}

// 重命名
function onResetName(item) {
  if (isUseArt()) {
    currentArtInfo.value = item
    artDialogType.value = 1
    artDialogShow.value = true
  }
}

// 编辑
function onEdit(item) {
  if (isUseArt()) {
    currentArtInfo.value = item
    isEdit.value = true
    call("showEdit", item)
  }
}

// 删除
function onDelete(item) {
  if (isUseArt()) {
    currentArtInfo.value = item
    artDialogType.value = 2
    artDialogShow.value = true
  }
}

// 清空勾选：删除、导入刷新后调用。之前只在"全选"时清空，导致被删掉的 id 残留在勾选里
function resetParams() {
  isChooseAll.value = false
  fileMap.value = {}
}

// 选中某一条
function onChooseItem(item) {
  if (fileMap.value[item.id]) {
    delete fileMap.value[item.id]
  }else {
    fileMap.value[item.id] = item
  }
  let chooseNum = Object.keys(fileMap.value).length
  let maxNum = fileList.value.length
  if (chooseNum == maxNum) {
    isChooseAll.value = true
  }else if (chooseNum == 0) {
    isChooseAll.value = false
  }
}

function onCloseDialog() {
  artDialogShow.value = false
  artImportDialogShow.value = false
  uploadRef.value && uploadRef.value.clearFiles()
}

function onImportConfirmDialog(dialogType) {
  pageNum.value = 1
  params.prevPageId = null
  params.nextPageId = null
  requestFileList(false, true)
  onCloseDialog()
}

function onChangePage(change) {
  console.log("onChangePage==>>>>", change, params, pageNum.value)
  if (fileList.value.length > 0) {
    const lastItem = fileList.value[fileList.value.length - 1];
    const firstItem = fileList.value[0];
    if (change === 'prev') {
      pageNum.value = pageNum.value - 1
      params.prevPageId = firstItem.id
      params.nextPageId = null
    }else if (change === 'next') {
      pageNum.value = pageNum.value + 1
      params.prevPageId = null
      params.nextPageId = lastItem.id
    }
    requestFileList(false, true)
  }
}

function onConfirmDialog(dialogType, infos) {
  if (!isUseArt()) {
    return
  }
  if (dialogType == 0) {
    // 创建术语库
    AccountServer.getCreateTerm(infos).then((result) => {
      if (result.code === "1") {
          pageNum.value = 1
          params.prevPageId = null
          params.nextPageId = null
          requestFileList(false, true)
          onCloseDialog()
      }else if (result.code == '10026') {
        artLibraryDialogRef.value && artLibraryDialogRef.value.showErrorText()
      }
    }).catch((result) => {
      if (result.code == '10026') { // 术语表名称已存在
        artLibraryDialogRef.value && artLibraryDialogRef.value.showErrorText()
      }else if (result.code == '10029') { // 术语表创建超出上限
        artDialogType.value = 10
        artDialogShow.value = true
      }else {
        Toast(result && result.message)
      } 
    })
  }else if (dialogType == 1) {
    if (currentArtInfo.value && currentArtInfo.value.id) {
      // 重命名
      AccountServer.getEditTerm({...infos, termId: currentArtInfo.value.id}).then((result) => {
        if (result.code === "1") {
            pageNum.value = 1
            params.prevPageId = null
            params.nextPageId = null
            requestFileList(false, true)
            onCloseDialog()
        }
      }).catch((result) => {
        if (result.code == '10026') {
          artLibraryDialogRef.value && artLibraryDialogRef.value.showErrorText()
        }else {
          Toast(result && result.message)
        } 
      })
    }
  }else if (dialogType == 2 || dialogType == 3) {
    let parmas = {}
    if (dialogType == 2) {
      parmas = {termIds: `${currentArtInfo.value.id || 0}`}
    }else if (dialogType == 3) {
      let ids = []
      Object.keys(fileMap.value).forEach((key)=>{
        ids.push(key)
      })
      parmas = {termIds: ids.join(",")}
    }
    // 删除
    AccountServer.getDeleteTerm(parmas).then((result) => {
      if (result.code === "1") {
          pageNum.value = 1
          params.prevPageId = null
          params.nextPageId = null
          requestFileList(false, true)
          onCloseDialog()
          resetParams()
      }
    }).catch((result) => {
      Toast(result && result.message)
    })
  }else if (dialogType == 4 || dialogType == 5 || dialogType == 10) {
    onUpPro()
    onCloseDialog()
  }
}

// 列表请求
function requestFileList(isInit = false, needLoading = true, typeStr?: string) {
  const context = glossaryContext.value
  if (!context) return
  const requestId = ++listRequestId
  let loading;
  if (needLoading) {
    let listDom = document.getElementById("fileArtList")
    if (listDom) {
      loading = ElLoading.service({
        lock: true,
        target: listDom
      })
    }
  }
  let param = {
    pageSize: 12,
    prevPageId: params.prevPageId,
    nextPageId: params.nextPageId,
  }

  if (searchString.value && searchString.value.length > 0) {
    param.termName = searchString.value 
  }

  if (typeStr) {
    param['type'] = typeStr
  }

  requestTotalCount(searchString.value || undefined, requestId, context)

  AccountServer.getUserTermlist(param).then((data)=> {
    if (requestId !== listRequestId || context !== glossaryContext.value) return
    console.log('data===', data)
    if (data.code == "1") {
      let list = data.list
      if (list && list.length > 0) {
        list.forEach((item)=>{
          if (currentArtInfo.value && currentArtInfo.value.id == item.id) {
            currentArtInfo.value = item
          }
        })
        fileList.value = list
        hasMore.value = true
        // if (list.length === params.pageSize) {
        //   hasMore.value = true
        // }else{
        //   hasMore.value = false
        // }
      }else {
        if (!params.prevPageId && !params.nextPageId) {
          fileList.value = []
        }

        if(params.nextPageId){
          Toast(t('doclingo_not_more_data'));
          hasMore.value = false
        }
        if(params.prevPageId){
          hasMore.value = true
        }
      }
    }
  }).catch(()=>{
    // 刷新失败保留已有数据，防止短暂网络失败把内容清空。
  }).finally(()=>{
    if (requestId === listRequestId && context === glossaryContext.value) initialListPending.value = false
    loading && loading.close()
  })
}

function requestTotalCount(termName: string | undefined, requestId: number, context: string) {
  const param = termName ? { termName } : {}
  AccountServer.getUserSearchTermlist(param).then((data) => {
    if (requestId !== listRequestId || context !== glossaryContext.value) return
    if (data?.code === '1' && Array.isArray(data.list)) {
      totalCount.value = data.list.length
    }
  }).catch(() => {
    // 总数仅用于展示，不影响主列表使用。
  })
}

// 外部调用
function onHideEdit() {
  isEdit.value = false
}

// 升级svip
function onUpPro() {
  call("onUpPro")
}



// 在组件卸载前移除全局滚动事件监听器
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
  document.removeEventListener('click', handleClickOutside);
});

</script>

<style scoped lang="scss">
@keyframes rotateAnimation {
  from{
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
.query_criteria_view{
  display: flex;
  align-items: center;
  position: relative;
  >div{
    min-width: 40px;
    font-size: 14px;
    overflow-wrap: break-word;
  }
  &:hover{
    cursor: pointer;
  }
}
.artLibraryList{
 
  .query_menu_view{
    font-size: 14px;
    margin-left:20px;
    .query_menu_title{
      line-height: 40px;
      &:hover{
        cursor: pointer;
      }

    }
  }
}
.pageNation{
  margin-top: 20px;
}

.art-table {
  display: flex;
  flex-direction: column;
}

.art-edit-table {
  display: flex;
  flex-direction: column;
}

.artTools {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 30px;
  .art-search {
    width: 200px;
    height: 30px;
  }
  .art-center-tools {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    .art-icon-view {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 2px;
      cursor: pointer;
      margin-left: 10px;
      &:hover {
        background-color: #F5F5F5;
      }
      .iconfont{
        font-size: 22px;
      }
      .icon-icon_download1 {
        color: #2590E1;
      }
      .icon-icon_Import {
        color: #2590E1;
      }
      .icon-icon_Export, .icon-icon_document_upload1 {
        color: #2590E1;
      }
    }
    .art-batch-view {
      padding: 2px 6px;
      border-radius: 4px;
      .art-batch-text {
        font-size: 12px;
        color: #2590E1;
        margin-left: 4px;
        white-space: nowrap;
      }
    }
    .art-tools-divider {
      width: 1px;
      height: 18px;
      background-color: #DCDCDC;
      margin-left: 14px;
      margin-right: 4px;
    }
  }
  .art-right {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .art-button {
      min-width: 100px;
    }
  }
}

.artLibraryList {
  display: flex;
  height: 533px;
  width: 100%;
  //padding: 0 30px;
  flex-direction: column;
  margin-top: 10px;
  border: 1px solid #BFBFBF;
  .fileTop {
    width: 100%;
    height: 40px;
    display: flex;
    background-color: #EAF5FC;
    flex-direction: row;
    align-items: center;
    // box-shadow: 0px 0.5px 0px 0.5px #BFBFBF;
    border-bottom: 1px solid #BFBFBF;
    .itemHeader {
      display: flex; flex-direction: row; width: 100%; height: 40px;
      align-items: center;
      .operateStart {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 25%;
        padding-left: 20px;
        cursor: pointer;
      }
      .operateEnd {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        width: 25%;
        padding-right: 20px;
      }
      .lock {
        margin-left: 10px;
        background: #FFFFFF;
        border-radius: 2px 2px 2px 2px;
        padding: 2px 5px;
        .lock-title {
          color: #595959;
          font-size: 12px;
          line-height: 12px;
        }
      }
      .title {
        font-size: 12px;
        color: var(--text-color1);
        margin-left: 5px;
      }
      .fileTop_first_title{
        margin-left: 20px;
      }
      .endTitle {
        font-weight: bold;
        font-size: 12px;
        color: var(--text-color1);
      }
      .failTitle {
        font-size: 12px;
        color: #E14C25;
      }
      .feedback—view{
        font-size: 12px;
        color:#2590E1;
        margin-right:10px;
      }
    }
    
  }
  .artList {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    .item {
      width: 100%;
      min-height: 40px;
      border-bottom: 1px solid #BFBFBF;
      display: flex;
      flex-direction: row;
      align-items: center;
      .item-title {
        font-size: 12px;
        color: var(--text-color1);
        margin-left: 5px;
      }
      .operateItemStart {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 25%;
        padding-left: 20px;
        cursor: pointer;
        .operateItemStart-title {
          font-size: 12px;
          color: var(--text-color1);
          margin-left: 5px;
          padding: 10px;
          white-space: nowrap;      /* 禁止换行 */
          overflow: hidden;         /* 超出部分隐藏 */
          text-overflow: ellipsis;  /* 超出部分显示省略号 */
        }
      }
      .operateItemEnd {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        width: 25%;
        padding-right: 20px;
        .item-end-title {
          font-size: 12px;
          color: #2590E1;
          margin-left: 10px;
          cursor: pointer;
          &:hover {
            opacity: 0.6;
          }
        }
        .delete_view{
          // color: var(--text-color1);
        }
      }

      .responsive_head{
        width: 100%;
        background-color: #EAF5FC;
        padding:8px 0;
        display: none;
        justify-content: space-between;
        align-items: center;
        border-radius: 6px 6px 0 0; /* 左上角和右上角圆角 */
        .responsive_head_time{
          margin-left:10px;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: var(--text-color1);
          .iconfont{
            margin-right:6px;
          }
        }
        .item-title {
          margin-right:10px;
        }
      }
      .responsive_body{
        padding:15px 0;
        width: 100%;
        display: none;
        .operateItemStart-title{
          margin-left: 10px;
        }
      }
    }
    .pageLast:last-child{
      border-bottom: none;
    }
    .blank {
      width: 100%;
      height: 100%;
      justify-content: center;
      flex-direction: column;
      display: flex;
      align-items: center;
      .icon-icon_blank_1 {
        font-size: 48px;
        color: #BFBFBF;
      }
      .blank-title {
        margin-top: 10px;
        font-size: 12px;
        color: #BFBFBF
      }
      .blank-btn {
        margin-top: 30px;
        min-width: 142px;
        height: 30px;
      }
      .blank-operate {
        margin-top: 10px;
        flex-direction: row;
        display: flex;
        align-items: center;
        .blank-download {
          font-size: 12px;
          color: #2590E1;
          cursor: pointer;
          &:hover {
            opacity: 0.6;
          }
        }
        .blank-space {
          width: 1px;
          height: 12px;
          background: #2590E1;
          margin: 0 10px;
        }
        .blank-import {
          font-size: 12px;
          color: #2590E1;
          cursor: pointer;
          &:hover {
            opacity: 0.6;
          }
        }
      }
      .blank-describe {
        margin-top: 30px;
        flex-direction: row;
        display: flex;
        align-items: center;
        cursor: pointer;
        .describe-title {
          color: #8C8C8C;
          font-size: 12px;
        }
        .icon-icon_arrowsrigh {
          color: #8C8C8C;
          font-size: 12px;
          margin-left: 4px;
        }
        &:hover {
          opacity: 0.6;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.glossary-library {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.glossary-upload {
  height: 0;
  overflow: hidden;
}

.glossary-library__body {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 12px;
}

.glossary-toolbar {
  display: flex;
  min-height: 34px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.glossary-search {
  display: flex;
  width: min(260px, 36vw);
  height: 34px;
  align-items: center;
  gap: 8px;
  padding: 0 11px;
  color: #98a2b3;
  background: #f2f4f7;
  border: 1px solid transparent;
  border-radius: 8px;
  transition: border-color 0.2s, background-color 0.2s;

  &:focus-within {
    color: #2b7de9;
    background: #fff;
    border-color: #2b7de9;
  }

  input {
    min-width: 0;
    flex: 1;
    color: #1f2329;
    font: inherit;
    font-size: 12px;
    background: transparent;
    border: 0;
    outline: 0;

    &::placeholder {
      color: #98a2b3;
    }

    &::-webkit-search-cancel-button {
      display: none;
    }
  }
}

.glossary-toolbar__group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.glossary-selection-bar {
  display: flex;
  width: 100%;
  height: 34px;
  align-items: center;
  gap: 16px;
  padding: 0 14px;
  color: #2b7de9;
  font-size: 12.5px;
  background: #eaf3ff;
  border-radius: 8px;

  strong { font-weight: 700; }

  button {
    padding: 0;
    color: #2b7de9;
    font: inherit;
    font-weight: 600;
    background: transparent;
    border: 0;
    cursor: pointer;

    &.is-danger { color: #e5484d; }
    &.is-cancel { color: #51565d; }
    &:disabled { color: #b8c0cc; cursor: not-allowed; }
  }
}

.glossary-menu-wrap {
  position: relative;
}

.glossary-menu {
  position: absolute;
  z-index: 30;
  top: calc(100% + 8px);
  right: 0;
  display: flex;
  width: 240px;
  flex-direction: column;
  gap: 2px;
  padding: 6px;
  background: #fff;
  border: 1px solid #e3e7ec;
  border-radius: 10px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12);

  button {
    display: flex;
    width: 100%;
    align-items: flex-start;
    gap: 8px;
    padding: 8px 10px;
    color: #51565d;
    text-align: left;
    background: #fff;
    border: 0;
    border-radius: 6px;
    cursor: pointer;

    // 操作入口不保留选中态，鼠标悬停或键盘聚焦时才高亮。
    &:hover,
    &:focus-visible {
      color: #2b7de9;
      background: #f5f9ff;
      strong { color: #2b7de9; }
    }

    // WorkbenchIcon 的根节点也是 span，不能让图标和正文各占一半宽度。
    > span:not(.workbench-icon) {
      display: flex;
      min-width: 0;
      flex: 1;
      flex-direction: column;
      gap: 2px;
    }

    strong {
      color: #1f2329;
      font-size: 12.5px;
      font-weight: 600;
      line-height: 18px;
    }


    small {
      color: #98a2b3;
      font-size: 11px;
      line-height: 16px;
    }
  }
}

.glossary-menu__divider {
  width: 100%;
  height: 1px;
  margin: 2px 0;
  background: #eef1f5;
}

.glossary-toolbar__divider {
  width: 1px;
  height: 20px;
  margin: 0 2px;
  background: #e8ebf0;
}

.glossary-icon-button,
.glossary-button,
.glossary-check,
.glossary-name,
.glossary-row-actions button {
  font: inherit;
}

.glossary-icon-button {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  color: #2b7de9;
  background: #fff;
  border: 1px solid #d9e0e8;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: #f5f9ff;
    border-color: #2b7de9;
  }
}

.glossary-button {
  display: inline-flex;
  height: 34px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 15px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;

  &:disabled {
    color: #b8c0cc;
    background: #f7f8fa;
    border-color: #e8ebf0;
    cursor: not-allowed;
  }
}

.glossary-button--primary {
  color: #fff;
  background: #2b7de9;
  border: 1px solid #2b7de9;

  &:hover {
    background: #1f6fd6;
  }
}

.glossary-button--secondary {
  color: #4b5563;
  background: #fff;
  border: 1px solid #d9e0e8;

  &:not(:disabled):hover {
    color: #2b7de9;
    border-color: #2b7de9;
  }
}

.glossary-table-shell {
  min-width: 0;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e8ebf0;
  border-radius: 10px;
}

.glossary-library-grid {
  display: grid;
  grid-template-columns: 26px minmax(180px, 1fr) 100px 220px 180px 240px;
  align-items: center;
  column-gap: 8px;
  padding: 0 16px;
}

.glossary-table-header {
  min-height: 42px;
  color: #51565d;
  font-size: 12px;
  font-weight: 600;
  background: #f5f9ff;
  border-bottom: 1px solid #e8ebf0;
}

.glossary-table-header__operation {
  text-align: right;
}

.glossary-table-body {
  position: relative;
  min-height: 420px;
}

.glossary-table-row {
  min-height: 46px;
  color: #51565d;
  font-size: 12px;
  border-bottom: 1px solid #f2f5f9;

  &:last-of-type {
    border-bottom: 0;
  }

  &:hover {
    background: #fbfdff;
  }
}

.glossary-check {
  display: inline-flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #fff;
  background: #fff;
  border: 1px solid #c8d0da;
  border-radius: 4px;
  cursor: pointer;

  &[aria-pressed='true'] {
    background: #2b7de9;
    border-color: #2b7de9;
  }
}

.glossary-name {
  min-width: 0;
  padding: 0;
  overflow: hidden;
  color: #1f2329;
  font-size: 12.5px;
  font-weight: 600;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: transparent;
  border: 0;

  &:disabled { cursor: default; }
}

.glossary-name-cell {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.glossary-official-tag {
  flex: 0 0 auto;
  padding: 2px 6px;
  color: #2b7de9;
  font-size: 10.5px;
  font-weight: 700;
  line-height: 16px;
  background: #eaf3ff;
  border-radius: 4px;
}

.glossary-lang-pair { flex: 0 0 auto; color: #8f959e; font-size: 12px; font-weight: 400; white-space: nowrap; }

.glossary-row-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;

  button {
    padding: 0;
    color: #2b7de9;
    font-size: 12px;
    background: transparent;
    border: 0;
    cursor: pointer;

    &:hover {
      color: #1f6fd6;
    }

    &.is-danger {
      color: #e05555;
    }

    &:disabled,
    &.is-danger:disabled {
      color: #b8c0cc;
      cursor: not-allowed;
    }
  }
}

.glossary-empty {
  display: flex;
  min-height: 420px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #98a2b3;
  text-align: center;

  strong {
    margin-top: 12px;
    color: #51565d;
    font-size: 13px;
    font-weight: 600;
  }

  p {
    margin: 6px 0 18px;
    color: #98a2b3;
    font-size: 12px;
  }
}

.glossary-empty__icon {
  display: inline-flex;
  width: 54px;
  height: 54px;
  align-items: center;
  justify-content: center;
  color: #2b7de9;
  background: #edf5ff;
  border-radius: 14px;
}

.glossary-empty__links {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;

  span {
    width: 1px;
    height: 11px;
    background: #d9e0e8;
  }

  button {
    padding: 0;
    color: #2b7de9;
    font-size: 12px;
    background: transparent;
    border: 0;
    cursor: pointer;
  }
}

.glossary-empty__help {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-top: 20px;
  padding: 0;
  color: #98a2b3;
  font-size: 12px;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.glossary-pagination {
  display: flex;
  min-height: 26px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: #98a2b3;
  font-size: 11.5px;
}

@media (max-width: 900px) {
  .glossary-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .glossary-search {
    width: 100%;
  }

  .glossary-toolbar__group {
    flex-wrap: wrap;
  }

  .glossary-table-shell {
    overflow-x: auto;
  }

  .glossary-library-grid {
    min-width: 980px;
  }
}
</style>

<style scoped>
.art-custom-input :deep(.el-input__inner) {
  background-color: #F5F5F5; /* 修改背景颜色 */
  border: none; /* 移除边框 */
  box-shadow: none; /* 移除默认的阴影 */
}

.art-custom-input :deep(.el-input__wrapper) {
  background-color: #F5F5F5; /* 修改背景颜色 */
  border: none; /* 移除边框 */
  box-shadow: none; /* 移除默认的阴影 */
}
</style>
<style lang="scss">
.AccountArtLibraryList input {
    font-size: 12px !important; /* 设置字体大小 */
}
.AccountArtLibraryList textarea {
  font-size: 12px !important; /* 设置字体大小 */
}
</style>
